// removed by extract-text-webpack-plugin
module.exports = {"component":"_1A3z4tw78OtDmLV_Ixs_Cm","header":"_1WVJzaA893SLKqnsBdEDd5","componentItem":"_2yx0mBo2rY3ghe0Ep7NaG4","messagePlaceholder":"c-kF343xw9HM2B7CDoyMo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Appointments/UpcomingAppointments/UpcomingAppointmentsContainer.css
// module id = 1411
// module chunks = 0